const { BROWSER, NODE_ENV } = process.env;

class AltResolver {

  didFetchData = false
  pendingActions = []

  resolve(action, setImmediate = (NODE_ENV === 'test')) {
    if (BROWSER && !this.didFetchData) {
      return action();
    } else if (setImmediate) {
      return action();
    }

    this.pendingActions = [...this.pendingActions, action];
  }

  async dispatchPendingActions() {
    for (const action of this.pendingActions) await action();
  }

}

export default AltResolver;



// WEBPACK FOOTER //
// ./shared/alt-resolver.js